var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.$style.grouperControl },
    [
      !_vm.anyLoading
        ? _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("toggle", _vm.ids)
                },
              },
            },
            [
              _vm.allSelected
                ? _c("i", { staticClass: "material-icons" }, [
                    _vm._v(" check_box "),
                  ])
                : _vm.someSelected
                ? _c("i", { staticClass: "material-icons" }, [
                    _vm._v(" indeterminate_check_box "),
                  ])
                : _c("i", { staticClass: "material-icons" }, [
                    _vm._v("check_box_outline_blank"),
                  ]),
            ]
          )
        : _c("rbv-loading", { attrs: { "rb-class": "small" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }